import { WindZoneEnum } from '@e-socna/data-layer';

export const windZoneLabels = {
  [WindZoneEnum.Zero]: '0',
  [WindZoneEnum.One]: '1',
  [WindZoneEnum.Two]: '2',
  [WindZoneEnum.Three]: '3',
  [WindZoneEnum.Four]: '4',
};
